// Keeps every open tab on the LATEST deploy. The build stamps a unique id into the
// app (__BUILD_ID__) and into /version.json. We poll version.json; when it differs
// from our baked id, a newer deploy is live and we hard-reload once to pick it up.
// This is why a phone that kept an old tab open can't get stuck on a stale bundle.

let reloaded = false;

async function currentDeployId(): Promise<string | null> {
  try {
    const res = await fetch(`${import.meta.env.BASE_URL}version.json?_=${Date.now()}`, {
      cache: 'no-store',
    });
    if (!res.ok) return null;
    const data = (await res.json()) as { buildId?: string };
    return data.buildId ?? null;
  } catch {
    return null;
  }
}

async function check() {
  if (reloaded) return;
  const latest = await currentDeployId();
  if (latest && latest !== __BUILD_ID__) {
    reloaded = true;
    // Hard reload — fetches a fresh index.html and the new hashed bundle.
    window.location.reload();
  }
}

export function startVersionWatch() {
  // Shortly after load, whenever the tab regains focus, and whenever it becomes
  // visible again (e.g. a phone returning to a backgrounded tab).
  setTimeout(check, 4000);
  window.addEventListener('focus', check);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') check();
  });
}
